// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import shared admin styles */
/* Shared Admin Component Styles */
/* Shared Design Variables for Admin Components */
:root {
  --primary-color: #7d48b0;
  --primary-light: #a78bc2;
  --primary-gradient: linear-gradient(135deg, #7d48b0 0%, #a78bc2 100%);
  --surface-white: #ffffff;
  --surface-gray-50: #fafbfc;
  --surface-gray-100: #f4f6f8;
  --surface-gray-200: #e8ecf0;
  --text-primary: #1a1d29;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --border-light: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  --radius-2xl: 20px;
}
/* Common Container Styles */
.admin-container {
  width: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}
/* Modern Card Design */
.admin-card {
  background: var(--surface-white);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  -webkit-box-shadow: var(--shadow-lg);
          box-shadow: var(--shadow-lg);
  backdrop-filter: blur(10px);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}
.admin-card .ant-card-body {
  padding: 0;
}
/* Page Header with Title and Filters */
.admin-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-bottom: 1rem;
  padding: 0.25rem 0rem;
  gap: 2rem;
}
.admin-page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.025em;
  text-transform: uppercase;
  white-space: nowrap;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}
/* Inline Filter Section */
.admin-filters-inline {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 1rem;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.admin-filters-inline .ant-input-affix-wrapper,
.admin-filters-inline .ant-select-selector {
  border: 1px solid #d1d5db;
  border-radius: var(--radius-md);
  -webkit-box-shadow: var(--shadow-sm);
          box-shadow: var(--shadow-sm);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  height: 40px;
}
.admin-filters-inline .ant-select-selection-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input::-webkit-input-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input::-moz-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input:-ms-input-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input::-ms-input-placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input::placeholder {
  color: #9ca3af !important;
  font-style: italic;
  opacity: 1 !important;
}
.admin-filters-inline .ant-input-affix-wrapper:hover,
.admin-filters-inline .ant-select-selector:hover {
  border-color: var(--primary-light);
  -webkit-box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);
          box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);
}
.admin-filters-inline .ant-input-affix-wrapper:focus-within,
.admin-filters-inline .ant-select-focused .ant-select-selector {
  border-color: var(--primary-color);
  -webkit-box-shadow: 0 0 0 3px rgb(239 130 0 / 0.15);
          box-shadow: 0 0 0 3px rgb(239 130 0 / 0.15);
}
.admin-filters-inline .ant-btn {
  height: 40px;
  border: 1px solid #d1d5db;
  border-radius: var(--radius-md);
  font-weight: 500;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-box-shadow: var(--shadow-sm);
          box-shadow: var(--shadow-sm);
}
.admin-filters-inline .ant-btn:hover {
  -webkit-box-shadow: var(--shadow-md);
          box-shadow: var(--shadow-md);
}
/* Enhanced Table Design */
.admin-table {
  border-radius: 0;
  overflow: hidden;
  -webkit-box-shadow: none;
          box-shadow: none;
}
/* .admin-table .ant-table-thead > tr > th {
  padding: 12px 16px !important;
  border-bottom: 2px solid var(--border-light);
  font-weight: 700;
  font-size: 0.875rem;
  color: var(--text-primary);
  text-transform: uppercase;
  letter-spacing: 0.025em;
  position: sticky;
  top: 0;
  z-index: 10;
} */
.admin-table .ant-table-tbody > tr {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.admin-table .ant-table-tbody > tr:hover {
  background: linear-gradient(135deg, var(--surface-gray-50) 0%, var(--surface-white) 100%);
}
.admin-table .ant-table-tbody > tr > td {
  padding: 10px 16px !important;
  border-bottom: 1px solid var(--border-light);
  font-weight: 500;
  color: var(--text-primary);
}
/* Modern Action Buttons */
.action-buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 6px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.action-buttons .ant-btn {
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-weight: 600;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border: none;
  height: 36px;
  padding: 0 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.action-buttons .ant-btn:hover {
  -webkit-box-shadow: var(--shadow-sm);
          box-shadow: var(--shadow-sm);
}
/* Enhanced Status Badges */
.status-active {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 2px 8px;
  background: rgb(218,243, 238);
  color: rgb(0, 121,92) !important;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.status-inactive {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 2px 8px;
  background: #c8bbbb;
  color: #e44f4f;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
}
/* Modern Error Container */
.error-container {
  margin: 1rem auto;
  padding: 1.5rem;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: var(--radius-lg);
  color: var(--danger-color);
  -webkit-box-shadow: var(--shadow-md);
          box-shadow: var(--shadow-md);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  font-weight: 500;
}
.retry-button {
  background: var(--danger-color);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  padding: 8px 16px;
  font-weight: 500;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.retry-button:hover {
  -webkit-box-shadow: var(--shadow-md);
          box-shadow: var(--shadow-md);
}
/* Pagination Styling */
.admin-table .ant-pagination {
  margin: 2rem 0 1rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.admin-table .ant-pagination .ant-pagination-item {
  border-radius: var(--radius-md);
  border: 1px solid var(--border-light);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.admin-table .ant-pagination .ant-pagination-item:hover {
  -webkit-box-shadow: var(--shadow-sm);
          box-shadow: var(--shadow-sm);
}
.admin-table .ant-pagination .ant-pagination-item-active {
  background: var(--primary-gradient);
  border-color: var(--primary-color);
}
.admin-table .ant-pagination .ant-pagination-item-active a {
  color: white;
  font-weight: 600;
}
/* Enhanced Responsive Design */
@media (max-width: 1400px) {
  .admin-header {
    gap: 1rem;
  }

  .admin-filters-inline {
    gap: 0.5rem;
  }

  .admin-filters-inline .ant-input-affix-wrapper {
    width: 250px;
  }

  .admin-filters-inline .ant-select {
    width: 140px;
  }
}
@media (max-width: 1200px) {
  .admin-header {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 1.5rem;
  }

  .admin-header .page-title {
    -ms-flex-item-align: center;
        align-self: center;
  }

  .admin-filters-inline {
    width: 100%;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }
}
@media (max-width: 768px) {
  .admin-header {
    padding: 1rem;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    text-align: center;
    gap: 1rem;
  }

  .admin-header .page-title {
    font-size: 1.5rem;
  }

  .admin-filters-inline {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    width: 100%;
    gap: 0.75rem;
  }

  .admin-filters-inline .ant-input-affix-wrapper,
  .admin-filters-inline .ant-select-selector,
  .admin-filters-inline .ant-btn {
    width: 100%;
  }

  .action-buttons {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 4px;
  }

  .action-buttons .ant-btn {
    width: 100%;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }

  .admin-table .ant-table-thead > tr > th,
  .admin-table .ant-table-tbody > tr > td {
    padding: 12px 8px !important;
  }
}
@media (max-width: 480px) {
  .admin-header .page-title {
    font-size: 1.5rem;
  }

  .admin-header {
    padding: 0.75rem;
  }

  .admin-card {
    margin: 0.5rem auto;
    border-radius: var(--radius-md);
  }
}
/* Reset potential scrollbar causes */
body, html {
  margin: 0 !important;
  padding: 0 !important;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
*, *::before, *::after {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
/* Edit Modal Styling */
.edit-user-modal__form-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 1rem;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.edit-user-modal__form-item {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 30%;
          flex: 1 1 30%;
  min-width: 200px;
}
.edit-user-modal__form .ant-form-item-label > label {
  font-weight: 600;
  color: var(--text-primary);
}
.edit-user-modal {
  top: 80px;
}
.edit-user-modal .ant-modal-body {
  overflow-y: auto;
  height: 50vh;
}
/* Main Container - extending admin styles */
.users-container {
  @extend .admin-container;
}
.users-container .ant-card {
  @extend .admin-card;
}
/* User Header - using admin header with alias */
.user-header {
  @extend .admin-header;
}
/* User Filters - using admin filters with alias */
.user-filters-inline {
  @extend .admin-filters-inline;
}
/* User Table - using admin table with alias */
.user-list-table {
  @extend .admin-table;
}
/* Enhanced Loading States */
.loading-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 300px;
  gap: 1rem;
}
.modal-loading {
  pointer-events: none;
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./pages/UserList/user-list.css","webpack://./styles/admin-components.css","webpack://./styles/admin-variables.css"],"names":[],"mappings":"AAAA,+BAA+B;ACA/B,kCAAkC;ACAlC,iDAAiD;AACjD;EACE,wBAAwB;EACxB,wBAAwB;EACxB,qEAAqE;EACrE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,0CAA0C;EAC1C,6EAA6E;EAC7E,+EAA+E;EAC/E,gFAAgF;EAChF,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;ADtBA,4BAA4B;AAC5B;EACE,WAAW;EACX,6DAA6D;AAC/D;AAEA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,oCAA4B;UAA5B,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAyB;EAAzB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AAEA;EACE,UAAU;AACZ;AAEA,uCAAuC;AACvC;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAc;MAAd,cAAc;AAChB;AAEA,0BAA0B;AAC1B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,oCAA4B;UAA5B,4BAA4B;EAC5B,iCAAyB;EAAzB,yBAAyB;EACzB,YAAY;AACd;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAJA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAJA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAJA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAJA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AAEA;;EAEE,kCAAkC;EAClC,kDAA0C;UAA1C,0CAA0C;AAC5C;AAEA;;EAEE,kCAAkC;EAClC,mDAA2C;UAA3C,2CAA2C;AAC7C;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAyB;EAAzB,yBAAyB;EACzB,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAgB;UAAhB,gBAAgB;AAClB;AAEA;;;;;;;;;;;GAWG;AAEH;EACE,iCAAyB;EAAzB,yBAAyB;AAC3B;AAEA;EACE,yFAAyF;AAC3F;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,gBAAgB;EAChB,0BAA0B;AAC5B;AAEA,0BAA0B;AAC1B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iCAAyB;EAAzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA,2BAA2B;AAC3B;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,eAAe;EACf,6DAA6D;EAC7D,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;EAC5B,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,gBAAgB;AAClB;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,iCAAyB;EAAzB,yBAAyB;AAC3B;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,iCAAyB;EAAzB,yBAAyB;AAC3B;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AAEA,+BAA+B;AAC/B;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;AAEA;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,2BAAkB;QAAlB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,mBAAe;QAAf,eAAe;EACjB;AACF;AAEA;EACE;IACE,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;AACF;AD1UA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,qBAAqB;EACrB,8BAAsB;UAAtB,sBAAsB;AACxB;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;AACxB;AAEA,uBAAuB;AACvB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;AAEA;EACE,mBAAa;MAAb,iBAAa;UAAb,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AAEA;EACE,SAAS;AACX;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AAEA,4CAA4C;AAC5C;EACE,wBAAwB;AAC1B;AAEA;EACE,mBAAmB;AACrB;AAEA,gDAAgD;AAChD;EACE,qBAAqB;AACvB;AAEA,kDAAkD;AAClD;EACE,6BAA6B;AAC/B;AAEA,8CAA8C;AAC9C;EACE,oBAAoB;AACtB;AAEA,4BAA4B;AAC5B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd","sourcesContent":["/* Import shared admin styles */\r\n@import '../../styles/admin-components.css';\r\n\r\n/* Reset potential scrollbar causes */\r\nbody, html {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  box-sizing: border-box;\r\n}\r\n\r\n*, *::before, *::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Edit Modal Styling */\r\n.edit-user-modal__form-row {\r\n  display: flex;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.edit-user-modal__form-item {\r\n  flex: 1 1 30%;\r\n  min-width: 200px;\r\n}\r\n\r\n.edit-user-modal__form .ant-form-item-label > label {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.edit-user-modal {\r\n  top: 80px;\r\n}\r\n\r\n.edit-user-modal .ant-modal-body {\r\n  overflow-y: auto;\r\n  height: 50vh;\r\n}\r\n\r\n/* Main Container - extending admin styles */\r\n.users-container {\r\n  @extend .admin-container;\r\n}\r\n\r\n.users-container .ant-card {\r\n  @extend .admin-card;\r\n}\r\n\r\n/* User Header - using admin header with alias */\r\n.user-header {\r\n  @extend .admin-header;\r\n}\r\n\r\n/* User Filters - using admin filters with alias */\r\n.user-filters-inline {\r\n  @extend .admin-filters-inline;\r\n}\r\n\r\n/* User Table - using admin table with alias */\r\n.user-list-table {\r\n  @extend .admin-table;\r\n}\r\n\r\n/* Enhanced Loading States */\r\n.loading-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 300px;\r\n  gap: 1rem;\r\n}\r\n\r\n.modal-loading {\r\n  pointer-events: none;\r\n  opacity: 0.7;\r\n}\r\n","/* Shared Admin Component Styles */\r\n@import './admin-variables.css';\r\n\r\n/* Common Container Styles */\r\n.admin-container {\r\n  width: 100%;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\r\n}\r\n\r\n/* Modern Card Design */\r\n.admin-card {\r\n  background: var(--surface-white);\r\n  border: 1px solid var(--border-light);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: var(--shadow-lg);\r\n  backdrop-filter: blur(10px);\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.admin-card .ant-card-body {\r\n  padding: 0;\r\n}\r\n\r\n/* Page Header with Title and Filters */\r\n.admin-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  padding: 0.25rem 0rem;\r\n  gap: 2rem;\r\n}\r\n\r\n.admin-page-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n  letter-spacing: -0.025em;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Inline Filter Section */\r\n.admin-filters-inline {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.admin-filters-inline .ant-input-affix-wrapper,\r\n.admin-filters-inline .ant-select-selector {\r\n  border: 1px solid #d1d5db;\r\n  border-radius: var(--radius-md);\r\n  box-shadow: var(--shadow-sm);\r\n  transition: all 0.2s ease;\r\n  height: 40px;\r\n}\r\n\r\n.admin-filters-inline .ant-select-selection-placeholder {\r\n  color: #9ca3af !important;\r\n  font-style: italic;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.admin-filters-inline .ant-input::placeholder {\r\n  color: #9ca3af !important;\r\n  font-style: italic;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.admin-filters-inline .ant-input-affix-wrapper:hover,\r\n.admin-filters-inline .ant-select-selector:hover {\r\n  border-color: var(--primary-light);\r\n  box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);\r\n}\r\n\r\n.admin-filters-inline .ant-input-affix-wrapper:focus-within,\r\n.admin-filters-inline .ant-select-focused .ant-select-selector {\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 3px rgb(239 130 0 / 0.15);\r\n}\r\n\r\n.admin-filters-inline .ant-btn {\r\n  height: 40px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: var(--radius-md);\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.admin-filters-inline .ant-btn:hover {\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n/* Enhanced Table Design */\r\n.admin-table {\r\n  border-radius: 0;\r\n  overflow: hidden;\r\n  box-shadow: none;\r\n}\r\n\r\n/* .admin-table .ant-table-thead > tr > th {\r\n  padding: 12px 16px !important;\r\n  border-bottom: 2px solid var(--border-light);\r\n  font-weight: 700;\r\n  font-size: 0.875rem;\r\n  color: var(--text-primary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.025em;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n} */\r\n\r\n.admin-table .ant-table-tbody > tr {\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.admin-table .ant-table-tbody > tr:hover {\r\n  background: linear-gradient(135deg, var(--surface-gray-50) 0%, var(--surface-white) 100%);\r\n}\r\n\r\n.admin-table .ant-table-tbody > tr > td {\r\n  padding: 10px 16px !important;\r\n  border-bottom: 1px solid var(--border-light);\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Modern Action Buttons */\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.action-buttons .ant-btn {\r\n  border-radius: var(--radius-md);\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n  border: none;\r\n  height: 36px;\r\n  padding: 0 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.action-buttons .ant-btn:hover {\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n/* Enhanced Status Badges */\r\n.status-active {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 8px;\r\n  background: rgb(218,243, 238);\r\n  color: rgb(0, 121,92) !important;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.status-inactive {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 8px;\r\n  background: #c8bbbb;\r\n  color: #e44f4f;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* Modern Error Container */\r\n.error-container {\r\n  margin: 1rem auto;\r\n  padding: 1.5rem;\r\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\r\n  border: 1px solid #fecaca;\r\n  border-radius: var(--radius-lg);\r\n  color: var(--danger-color);\r\n  box-shadow: var(--shadow-md);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-weight: 500;\r\n}\r\n\r\n.retry-button {\r\n  background: var(--danger-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  padding: 8px 16px;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.retry-button:hover {\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n/* Pagination Styling */\r\n.admin-table .ant-pagination {\r\n  margin: 2rem 0 1rem;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.admin-table .ant-pagination .ant-pagination-item {\r\n  border-radius: var(--radius-md);\r\n  border: 1px solid var(--border-light);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.admin-table .ant-pagination .ant-pagination-item:hover {\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.admin-table .ant-pagination .ant-pagination-item-active {\r\n  background: var(--primary-gradient);\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.admin-table .ant-pagination .ant-pagination-item-active a {\r\n  color: white;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Enhanced Responsive Design */\r\n@media (max-width: 1400px) {\r\n  .admin-header {\r\n    gap: 1rem;\r\n  }\r\n\r\n  .admin-filters-inline {\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .admin-filters-inline .ant-input-affix-wrapper {\r\n    width: 250px;\r\n  }\r\n\r\n  .admin-filters-inline .ant-select {\r\n    width: 140px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .admin-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .admin-header .page-title {\r\n    align-self: center;\r\n  }\r\n\r\n  .admin-filters-inline {\r\n    width: 100%;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .admin-header {\r\n    padding: 1rem;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .admin-header .page-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .admin-filters-inline {\r\n    flex-direction: column;\r\n    width: 100%;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .admin-filters-inline .ant-input-affix-wrapper,\r\n  .admin-filters-inline .ant-select-selector,\r\n  .admin-filters-inline .ant-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  .action-buttons {\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n\r\n  .action-buttons .ant-btn {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .admin-table .ant-table-thead > tr > th,\r\n  .admin-table .ant-table-tbody > tr > td {\r\n    padding: 12px 8px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .admin-header .page-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .admin-header {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .admin-card {\r\n    margin: 0.5rem auto;\r\n    border-radius: var(--radius-md);\r\n  }\r\n}\r\n","/* Shared Design Variables for Admin Components */\r\n:root {\r\n  --primary-color: #7d48b0;\r\n  --primary-light: #a78bc2;\r\n  --primary-gradient: linear-gradient(135deg, #7d48b0 0%, #a78bc2 100%);\r\n  --surface-white: #ffffff;\r\n  --surface-gray-50: #fafbfc;\r\n  --surface-gray-100: #f4f6f8;\r\n  --surface-gray-200: #e8ecf0;\r\n  --text-primary: #1a1d29;\r\n  --text-secondary: #6b7280;\r\n  --text-muted: #9ca3af;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --warning-color: #f59e0b;\r\n  --border-light: #e2e8f0;\r\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\r\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\r\n  --radius-sm: 6px;\r\n  --radius-md: 8px;\r\n  --radius-lg: 12px;\r\n  --radius-xl: 16px;\r\n  --radius-2xl: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
